import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { ScoreStatus } from '@sorare/core/src/__generated__/globalTypes';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyM, BrandM, LabelS } from '@sorare/core/src/atoms/typography';
import { Score } from '@sorare/core/src/components/scoring/Score';
import { fantasy } from '@sorare/core/src/lib/glossary';

import { TutorialBezel } from '../../TutorialBezel';
import cutPlayerCard from '../../assets/cutPlayerCard.png';

const Img = styled.img`
  position: relative;
  bottom: calc(-1 * var(--double-unit));
  width: calc(12 * var(--unit));
  height: calc(100% + var(--double-unit));
  object-fit: cover;
`;

export const L10Average = () => {
  return (
    <TutorialBezel color="var(--c-green-400)">
      <Vertical gap={2.5}>
        <Vertical center className="text-center">
          <BrandM>
            <FormattedMessage
              id="L10Average.title"
              defaultMessage="Every player has a L10*"
            />
          </BrandM>
          <BodyM color="var(--c-nd-600)">
            <FormattedMessage
              id="L10Average.description"
              defaultMessage="<em>*L10</em> = Last 10 Game Average"
              values={{
                em: chunks => (
                  <BodyM bold color="var(--c-white)" as="span">
                    {chunks}
                  </BodyM>
                ),
              }}
            />
          </BodyM>
        </Vertical>
        <Horizontal center>
          <Img src={cutPlayerCard} alt="" />
          <Vertical center>
            <LabelS bold color="var(--c-nd-600)">
              <FormattedMessage {...fantasy.l10} />
            </LabelS>
            <Score
              hideReviewing
              shape="HEXAGON"
              score={50}
              scoreStatus={ScoreStatus.FINAL}
              scoreType="PLAYER_SCORE"
            />
          </Vertical>
        </Horizontal>
      </Vertical>
    </TutorialBezel>
  );
};
